import React from "react"

const PGraph = () => {
  return (
    <div id="p-chart-sm" className=" uk-flex-top " data-uk-modal>
      <button
        className="uk-modal-close-full uk-close"
        type="button"
        data-uk-close
        style={{
          position: "fixed",
          right: "0",
          top: "0"
        }}
      ></button>
      <div className="uk-modal-dialog uk-margin-auto-vertical">
        <div
          id="p-chart-small"
          style={{ width: "90%", minHeight: "40%" }}
        ></div>
      </div>
    </div>
  )
}

export default PGraph
